<template>
  <div>
    <v-stepper-step :complete="current > step" :step="step" :editable="!!type" color="#FF696F" :id="`project-step-${step}`">
      Quel type d'espace ? <span class="overline">{{type}}</span>
    </v-stepper-step>

    <v-stepper-content :step="step">
      <v-card>
        <v-row :class="{'d-flex': true, 'flex-column': $vuetify.breakpoint.xsOnly}">
          
          <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
            <v-card max-width="300" class="mx-2">
              <v-img 
                height="120px" 
                src="/gimc/storage/assets/form/balcon.jpg" 
                lazy-src="/gimc/storage/assets/form/balcon.jpg?thumb=true" 
                contain
              >
              </v-img>

              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="type" @change="$emit('change', type)">
                  <v-radio value="balcon"  label="Balcon"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </v-col>
        
          <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
            <v-card max-width="300" class="mx-2">
              <v-img 
                height="120px" 
                src="/gimc/storage/assets/form/terasse.jpg" 
                lazy-src="/gimc/storage/assets/form/terasse.jpg?thumb=true" 
                contain
              >
              </v-img>
              
              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="type" @change="$emit('change', type)">
                  <v-radio value="terrasse" label="Terrasse"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </v-col>
        
          <v-col :cols="$vuetify.breakpoint.xsOnly ? 12 : 4">
            <v-card max-width="300" class="mx-2">
              <v-img 
                height="120px" 
                src="/gimc/storage/assets/form/jardin.jpg" 
                lazy-src="/gimc/storage/assets/form/jardin.jpg?thumb=true" 
                contain
              >
              </v-img>

              <v-card-actions class="justify-center align-center">
                <v-radio-group v-model="type" @change="$emit('change', type)">
                  <v-radio value="jardin"  label="Jardin"></v-radio>
                </v-radio-group>
              </v-card-actions>
            </v-card>
          </v-col>
          
        </v-row>

        <v-card-actions v-if="!!type">
          <v-btn outlined color="#0b755f" @click="$emit('change', type)" >Suivant</v-btn>
        </v-card-actions>
      </v-card>
    </v-stepper-content>
  </div>
</template>

<script>
export default {
  model: { prop: 'data', event: 'change' },
  props: {
    data: String,
    step: Number,
    current: Number
  },
  data: () => ({
    type: ''
  }),
  beforeMount () {
    this.type = this.data
  }
}
</script>